import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { User } from '../../models/User';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { faGlobe } from '@fortawesome/free-solid-svg-icons';
import { faPenToSquare } from '@fortawesome/free-solid-svg-icons';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-user-details-modal',
  templateUrl: './user-details-modal.component.html',
  styleUrls: ['./user-details-modal.component.scss'],
})
export class UserDetailsModalComponent implements OnInit {
  @Input()
  selectedUser!: User;

  user: any;
  isAdmin: boolean = false;

  faUser = faUser;
  faGlobe = faGlobe;
  faPenToSquare = faPenToSquare;

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.isAdmin = this.checkIfLoggedInUserIsAdmin();
  }

  navigateToUpdate(id: any) {
    if (id != undefined) {
      document.getElementById('closeModalButton')?.click();
      this.router.navigateByUrl('/update/' + id);
    }
  }

  checkIfLoggedInUserIsAdmin(): boolean {
    this.user = JSON.parse(localStorage.getItem('user') || '{}');
    if (this.user != null && this.user.idTokenClaims != undefined) {
      let groups: string[] = this.user.idTokenClaims['groups'] as string[];
      if (
        groups.includes(environment.adminGroupID) ||
        groups.includes(environment.superAdminGroupID)
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
}
